// hasAccessDirective.js

import { watchEffect } from 'vue';
import { GetUserData } from '~/constants/getters';

/**
 * Hides or disable an ui element based on binding.arg
 * Usability: v-has-access:hide="['admin']" or v-has-access:disabled="['admin']"
 * @param {HTMLElement} 'el' - current html element
 * @param {Object} 'binding' - values sent to the directive
 */

export default {
  mounted(el, binding) {
    const resource = binding.value.resource;
    const action = binding.value.resource_action;

    if (!resource || !action) {
      return;
    }

    const stop = watchEffect(() => {
      const permissions = binding.instance.$store.getters[`authStore/${GetUserData}`]?.permissions || {};
      const hasAccess = permissions[resource]?.[action] ?? false;

      if (!hasAccess) {
        if (binding.arg === 'hide') {
          el.style.display = 'none';
        } else if (binding.arg === 'disabled') {
          el.style.pointerEvents = 'none';
          el.style.opacity = '1';
          el.style.backgroundColor = 'transparent';
          el.style.border = '1px solid #e8e7e5';
        }
      } else {
        if (binding.arg === 'hide') {
          el.style.display = '';
        } else if (binding.arg === 'disabled') {
          el.style.pointerEvents = '';
          el.style.opacity = '';
          el.style.backgroundColor = '';
          el.style.border = '';
        }
      }
    });

    el._stopAccessWatcher = stop;
  },
  beforeUnmount(el) {
    el._stopAccessWatcher?.();
  },
};
